var board_menu_hack = {
	init : function()
    {
        var y = 0;
		$( '.lia-menu-dropdown-items' ).find( 'li[aria-hidden!="true"]' ).each( function( i, el )
        {
            if( y % 2 )
            {
                $( this ).children().addClass( 'dropDownGrey' );
            }

            y++;
        } )
	}
};
